<ng-template #dialogTemplate class="relative">
  <div class="h-[100%]">
    <app-project-stages></app-project-stages>
  </div>
</ng-template>
